import React from "react";
import PropTypes from "prop-types";

const NumberInput = ({
  name,
  title,
  type,
  value,
  error,
  handleChange,
  placeholder,
  className,
}) => {
 
  return (
    <div className=" mx-2 mb-2">
    {title &&  <label className="d-flex align-items-center fs-12 fw-semibold mb-1">
      <span className="required">{title}</span>
    </label> }
   

    <input
      type={'number'}
      className={className ? className : "form-control  form-control-solid"}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
   
        handleChange(e);
      }}
      
      onKeyDown={(e) => {
        console.log(34, e)
        if (e.charCode !== 46) {
          if (e.key.match(/^[+-]?([0-9]*[.])?[0-9]+$/) === null) {
            console.log(e.charCode, "if");
            e.preventDefault();
          } else {
            console.log("else");
          }
        } else {
        }
      
      }}
    />
    <span className="fs-10 text-danger">{error}</span>
  </div>
  );
};

NumberInput.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};
export default NumberInput;
